import React, { useState, useEffect, useRef } from "react";
import "./ModalPagoSeguro.css";
import tarjeta from "./../../../assets/iconos/tarjeta.png";
import pagoEfectivo from "./../../../assets/iconos/pagoefectivo.png";
import Modal from "react-bootstrap/Modal";
import { registrarPagoPasarela } from "../../../services/procesoMatricula/pagoPasarela";

import {
  insertRespuestaPasarela,
  listado_datos_personalesReturn,
  listado_seguroDatos,
  listado_seguroPreliquidacion,
  urlPasarelaSafetyPay,
  validar_seguro_upch,
  update_paso,
} from "../../../services/procesoMatricula/procesoMatricula";
import useMatricula from "../../../hooks/useMatricula";
import useProcesoMatricula from "../../../hooks/useProcesoMatricula";
import {
  codigoApp,
  pasarelaSafetyPay,
} from "../../../config/constantes";
import Payment from "../Payment/Payment";
import { pasarelaPayment } from "../../../config/constantes";
import { formatFechaEnvioBD } from "../../../utils/formatFechaEnvioBD";

const ModalPagoSeguro = ({
  show,
  handleClose,
  handleSecondaryShow,
  showSecondary,
  handleSecondaryClose,
  seguroDatos,
  showSecondaryPayment,
  handleShowModalRequest,
  listDatosPersonalesPreli,
  onPagoExitoso,
}) => {
  const [voucherType, setVoucherType] = useState("1");
  const { ccod_art, descripcion, cmoneda, dmoneda, nmonto } = seguroDatos || {};

  const [abrirModalSafetyPay, setAbrirModalSafetyPay] = useState(false);
  const { obtenerDatosEstudiante } = useMatricula();

  const [urlModalSafetyPay, setUrlAbrirModalSafetyPay] = useState(null);

  const [cpeidodPreliquidacion, setCpeidodPreliquidacion] = useState({});

  const { setLoading } = useProcesoMatricula();

  const handleChange = (event) => {
    setVoucherType(event.target.value);
  };

  const formatCodeCurrencyISO4217 = (codigoMoneda) => {
    let currencyCode = {
      "01": "PEN",
      "02": "USD",
    };

    return currencyCode[codigoMoneda];
  };

  const handlePagarSafetypay = async () => {
    try {
      setLoading(true);

      let preliquidacion = await listado_seguroPreliquidacion(
        obtenerDatosEstudiante,
        "SAF"
      );

      const { cnropedido, cpreliquidacion } = preliquidacion;
      setCpeidodPreliquidacion({
        cnropedido: cnropedido,
        cpreliquidacion: cpreliquidacion,
      });

      if (cnropedido) {
        let datosPersonales = await listado_datos_personalesReturn(
          obtenerDatosEstudiante,
          setLoading,
          true
        );

        let {
          nombre,
          ape_paterno,
          ape_materno,
          ncelular,
          ccorreo,
        } = datosPersonales || {};

        let datosPayment = {
          value: nmonto,
          currency_code: formatCodeCurrencyISO4217(),
          phone_number: ncelular,
          first_name: nombre,
          last_names: ape_paterno + " " + ape_materno,
          emails: ccorreo,
          language_code: "ES",
          merchant_sales_id: cnropedido,
          application_id: codigoApp,
          product_id: ccod_art,
        };

        const respuesta = await urlPasarelaSafetyPay(datosPayment);

        const { gateway_token_url, operation_id } = respuesta;
        //Si abre correctamente la url safety pay Inserta la trama a la bd
        let inputs = {
          p_cpreliquidacion: cpreliquidacion,
          p_nnropedido: cnropedido,
          p_ntipopago: 2,
          p_montopago: nmonto,
          p_nexistoso: 1,
          p_ntrasaccion: "",
          p_ftransacion: formatFechaEnvioBD(new Date()),
          p_drespuesta: JSON.stringify(respuesta),
          p_ntarjeta: "",
          p_ctipotarjeta: "",
          p_ctip_pago: "SAF",
          p_gpagado: 0,
          p_operation_id: operation_id,
        };
        await insertRespuestaPasarela(obtenerDatosEstudiante, inputs);
        setAbrirModalSafetyPay(true);
        setUrlAbrirModalSafetyPay(gateway_token_url);
        handleSecondaryClose(pasarelaSafetyPay);
      } else {
        throw new Error("No existe cpreliquidacion");
      }
    } catch (error) {
      const { cnropedido, cpreliquidacion } = cpeidodPreliquidacion;
      let inputs = {
        p_cpreliquidacion: cpreliquidacion || "",
        p_nnropedido: cnropedido || "",
        p_ntipopago: 2,
        p_montopago: nmonto,
        p_nexistoso: 0,
        p_ntrasaccion: "",
        p_ftransacion: formatFechaEnvioBD(new Date()),
        p_drespuesta: error.message,
        p_ntarjeta: "",
        p_ctipotarjeta: "",
        p_ctip_pago: "SAF",
        p_gpagado: 0,
        p_operation_id: "",
      };
      await insertRespuestaPasarela(obtenerDatosEstudiante, inputs);
      handleShowModalRequest("error", "Error", error.message);
    } finally {
      setLoading(false);
    }
  };

  const handlePagarSafetypay1 = async () => {
    setAbrirModalSafetyPay(true);
    setUrlAbrirModalSafetyPay(
      "https://sandbox-gateway.safetypay.com/Express4/Checkout/index?TokenID=ef8913c7-8e9b-4238-95df-c676d0e8a9d1&CountryID=PER&ChannelID=ONLINE"
    );
    handleSecondaryClose(pasarelaSafetyPay);
  };

  // Limpiamos el celular: quitamos espacios, el "+" y el prefijo "51" si viene incluido
  const limpiarCelular = (celular) => {
    if (!celular) return "";

    let limpio = String(celular).trim().replace(/\s+/g, "").replace("+", "");

    if (limpio.startsWith("51") && limpio.length > 9) {
      limpio = limpio.slice(2);
    }

    return limpio;
  };

  //nueva pasarela V2
  const handlePagarNuevaPasarela = async () => {
    console.log("[PAGO DEBUG] 1. Iniciando...");

    handleSecondaryClose(pasarelaPayment);

    try {
      setLoading(true);

      // ============================================================
      // 1. Obtener datos frescos del seguro
      // ============================================================
      const datosSeguroFresh = await listado_seguroDatos(obtenerDatosEstudiante);

      const {
        nmonto: nmontoFresh,
        ccod_art: ccodArtFresh,
        cmoneda: cmonedaFresh,
      } = datosSeguroFresh || {};

      if (!nmontoFresh) {
        throw new Error("No se pudo obtener el monto a pagar.");
      }

      // ============================================================
      // 2. Datos del estudiante (MOVIDO AQUÍ PARA EVITAR ERROR DE INICIALIZACIÓN)
      // ============================================================
      const {
        ndocidentidad,
        cinstitucion,
        cprograma,
        cperiodo,
        cpersona,
      } = obtenerDatosEstudiante;

      // ============================================================
      // 3. Obtener datos personales
      // ============================================================
      const datosPersonales = await listado_datos_personalesReturn(
        obtenerDatosEstudiante,
        setLoading,
        true
      );

      const {
        nombre,
        ape_paterno,
        ape_materno,
        ncelular,
        ccorreo,
      } = datosPersonales || {};

      // Ahora ndocidentidad ya existe y puede ser usada aquí
      localStorage.setItem(
        "datos_pagador_pago",
        JSON.stringify({
          nombre_completo: nombre || "",
          apellido_paterno: ape_paterno || "",
          apellido_materno: ape_materno || "",
          numero_celular: limpiarCelular(ncelular),
          correo: ccorreo || "",
          tipo_documento: "DNI",
          numero_documento: String(ndocidentidad || ""),
        })
      );
      
      // ... resto del código (Moneda, Payload, etc.)
      const monedaISO = cmonedaFresh === "02" ? "USD" : "PEN";
      const currentHost = window.location.origin;

      const payload = {
        monto: String(nmontoFresh),
        moneda: monedaISO,
        correo: ccorreo,
        nombre_completo: nombre,
        apellido_paterno: ape_paterno,
        apellido_materno: ape_materno,
        ciudad: "Lima",
        codigo_pais: "51",
        numero_celular: limpiarCelular(ncelular),
        numero_documento: String(ndocidentidad),
        pais_origen: "Peru",
        tipo_comprobante: "B",
        tipo_documento: "DNI",
        nund: "1",
        monto_u: String(nmontoFresh),
        url_respuesta: `${currentHost}/payme/finish`,
        datos_adicionales: {
          nombreProyecto: "matricula",
          cinstitucion: String(cinstitucion),
          cprograma: String(cprograma),
          cperiodo: String(cperiodo),
          cpersona: String(cpersona),
          codtarifa: ccodArtFresh,
          ccod_art: ccodArtFresh,
        },
      };

      const data = await registrarPagoPasarela(payload);

      if (data?.success && data?.url) {
        window.location.href = data.url; //
      } else {
        throw new Error(data?.message || "Error en los datos de la pasarela");
      }

    } catch (error) {
      handleShowModalRequest("error", "Error", error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      show={show}
      onHide={handleClose}
      centered
      size="xl"
      backdrop="static"
      keyboard={false}
    >
      <Modal.Header closeButton>
        <Modal.Title>
          <h5 className="modal-title">Pagar seguro contra accidentes</h5>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {/* <button onClick={handleSecondaryShow}>Open Secondary Modal</button> */}
        <div className="row">
          <nav>
            <div
              className="nav nav-tabs bancos justify-content-between"
              id="nav-tab"
              role="tablist"
            >
              <button
                className="nav-link d-flex align-items-center justify-content-center active"
                id="nav-home-tab"
                data-bs-toggle="tab"
                data-bs-target="#nav-home"
                type="button"
                role="tab"
                aria-controls="nav-home"
                aria-selected="true"
              >
                {" "}
                <i className="bi bi-credit-card me-1 text-upch" />{" "}
                <span>Pagar con tarjeta de crédito/debito</span>
              </button>
              <button
                className="nav-link d-flex align-items-center justify-content-center "
                id="nav-safety-tab"
                data-bs-toggle="tab"
                data-bs-target="#nav-safety"
                type="button"
                role="tab"
                aria-controls="nav-safety"
                aria-selected="false"
              >
                {" "}
                <i className="bi bi-cash me-1 text-upch" />{" "}
                <span>Pago con SafetyPay</span>
              </button>
              <button
                className="nav-link d-flex align-items-center justify-content-center "
                id="nav-contact-tab"
                data-bs-toggle="tab"
                data-bs-target="#nav-contact"
                type="button"
                role="tab"
                aria-controls="nav-contact"
                aria-selected="false"
              >
                {" "}
                <i className="bi bi-building me-1 text-upch" />{" "}
                <span>Pago en caja cayetano</span>
              </button>
            </div>
          </nav>
          <div className="tab-content" id="nav-tabContent">
            <div
              className="tab-pane fade show active"
              id="nav-home"
              role="tabpanel"
              aria-labelledby="nav-home-tab"
            >
              <div className="border rounded-3 mt-4 mb-2 py-2 px-3 ">
                <div className="d-flex text-left">
                  <p className="me-2 fw-medium mb-0 pt-1">
                    Tarjeta de Crédito / Débito
                  </p>
                  <img src={tarjeta} />
                  <img src={pagoEfectivo} />
                </div>
                <div className="text-center mb-3">
                  <button
                    type="button"
                    className="btn btn-primary px-3"
                    onClick={() => handleSecondaryShow(pasarelaPayment)}
                  >
                    Ir a pagar
                  </button>

                  <Modal
                    show={showSecondaryPayment}
                    onHide={() => handleSecondaryClose(pasarelaPayment)}
                    centered
                    backdrop="static"
                    keyboard={false}
                    className="modal-pago-upch-final"
                  >
                    <Modal.Header closeButton className="border-0 pb-0">
                      <Modal.Title className="ps-3 pt-2 title-modal-payment">
                        Pago con Payment
                      </Modal.Title>
                    </Modal.Header>
                    <Modal.Body className="px-4 pb-4 pt-2">
                      <div className="pago-card-inner">
                        {/* Banner Rojo */}
                        <div className="pago-banner-rojo">
                          <div className="pago-logo-white">
                            <img
                              src="https://s3.amazonaws.com/ecosistema.documentos.upch/logo/logo_oficial_upch.png"
                              alt="Logo UPCH"
                            />
                          </div>
                        </div>

                        {/* Contenedor de texto con padding para que no se corte */}
                        <div className="pago-content-wrapper text-center">
                          <p className="pago-text-producto">
                            {descripcion || "SEGURO ACCIDENTES ESTUDIANTES"}
                          </p>

                          <h2 className="pago-text-monto">
                            $ {nmonto}
                          </h2>

                          <p className="pago-text-descripcion">
                            Serás redirigido a la pasarela de pagos segura de la UPCH para completar el pago con tu tarjeta de crédito o débito.
                          </p>

                          <div className="pb-2">
                            <button
                              className="pago-btn-red-final"
                              onClick={handlePagarNuevaPasarela}
                            >
                              Pagar $ {nmonto}
                            </button>
                          </div>
                        </div>
                      </div>
                    </Modal.Body>
                  </Modal>


                </div>
              </div>
            </div>
            <div
              className="tab-pane fade show "
              id="nav-safety"
              role="tabpanel"
              aria-labelledby="nav-safety-tab"
            >
              <div className="text-center py-4 border rounded-3 mt-4">
                <img
                  src="../../assets/pago1.png"
                  className="img-safetypay d-none"
                />
                <button
                  type="button"
                  className="btn waves-effect waves-light btn-primary siguiente mt-2 mb-2"
                  id="pagarModalBtn"
                  onClick={(e) => {
                    handleSecondaryShow(pasarelaSafetyPay);
                  }}
                >
                  Generar código Pago
                </button>

                <Modal
                  show={showSecondary}
                  onHide={(e) => {
                    handleSecondaryClose(pasarelaSafetyPay);
                  }}
                  centered
                  size="lg"
                  backdrop="static"
                  keyboard={false}
                  // dialogClassName="modalContent"
                  backdropClassName="modalGenerateCode"
                >
                  <Modal.Header closeButton>
                    <Modal.Title>
                      <h5 className="modal-title">Generar código de pago</h5>
                    </Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    <div className="row">
                      <div className="col-12">
                        <div className="card border rounded-3 ">
                          <div className="card-body">
                            <p className="fw-medium mb-0">Codigo: {ccod_art}</p>
                            <p className="fw-medium mb-0">
                              Descripción: {descripcion}.
                            </p>
                            <p className="fw-medium mb-0">
                              Monto: {dmoneda + " " + nmonto}
                            </p>
                            <p className="fw-medium mb-0">Boleta: </p>
                            <form
                              className="d-flex justify-content-start"
                              id="myForm"
                            >
                              <div className="form-check me-4">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="flexRadioDefault"
                                  id="boletaButton1"
                                  value="1"
                                  onChange={handleChange}
                                  checked={voucherType === "1"}
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor="boletaButtont1"
                                >
                                  Boleta Electrónica
                                </label>
                              </div>
                              <div className="form-check">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="flexRadioDefault"
                                  id="boletaButton2"
                                  value="2"
                                  onChange={handleChange}
                                  checked={voucherType === "2"}
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor="boletaButton2"
                                >
                                  Factura Electrónica
                                </label>
                              </div>
                            </form>
                          </div>
                        </div>

                        {voucherType === "2" && (
                          <div
                            className="alert alert-primary mt-3 factura-alert"
                            role="alert"
                            id="alertFactura"
                          >
                            De necesitar una factura, por favor comunicarse con
                            el área correspondiente.
                          </div>
                        )}
                      </div>
                    </div>
                  </Modal.Body>
                  <Modal.Footer>
                    {voucherType === "1" && (
                      <button
                        type="button"
                        className="btn btn-primary btn-safetypay"
                        id="pagarBtnSafetypay"
                        onClick={handlePagarSafetypay}
                      >
                        Pagar
                      </button>
                    )}
                  </Modal.Footer>
                </Modal>

                <Modal
                  show={abrirModalSafetyPay}
                  onHide={(e) => {
                    setAbrirModalSafetyPay(false);
                    setUrlAbrirModalSafetyPay(null);
                  }}
                  backdrop="static"
                  keyboard={false}
                  centered
                  size="xl"
                  // dialogClassName="modalContent"
                  backdropClassName="modalGenerateCode"
                >
                  <Modal.Header closeButton>
                    <Modal.Title>
                      <h5 className="modal-title">Safety-Pay</h5>
                    </Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    {urlModalSafetyPay !== null ? (
                      <div>
                        <img src="https://s3.amazonaws.com/ecosistema.documentos.upch/logo/logo_oficial_upch.png" className="logo-upch-v2" ></img>
                        <iframe
                          style={{ width: "100%", height: "500px" }}
                          src={urlModalSafetyPay}
                        ></iframe>
                      </div>
                    ) : (
                      "Upps hubo un error inesperado, por favor intentar mas tarde."
                    )}
                  </Modal.Body>
                </Modal>
              </div>
            </div>
            <div
              className="tab-pane fade"
              id="nav-contact"
              role="tabpanel"
              aria-labelledby="nav-contact-tab"
            >
              <div className="py-4">
                {/* <p clss="text-uppercase fw-bolder fs-reg mb-3">PAGO EN CAJAS CAYETANO</p> */}
                <div className="border rounded-3 mb-2 py-2 px-3 ">
                  <p className="fw-bold pt-1">Pasos a seguir:</p>
                  <p className="fw-regular">
                    También puedes acercarte a las cajas de la universidad,
                    ubicadas en las diferentes sedes:
                    <br />
                    <br />
                  </p>
                  <div className="d-flex gap-1 justify-content-between">
                    <div className="w-25 sede-div">
                      <div className="text-center mb-2">
                        <h4>
                          <i className="bi bi-geo-alt text-upch me-1" />
                        </h4>
                        <span className="fw-medium">
                          Caja Sede San Martín de Porres:
                        </span>
                      </div>
                      <div className="text-center">
                        <p className="fw-regular text-center mb-0">
                          - Lunes a viernes de 8:00 a.m. a 4:45 p.m.{" "}
                        </p>
                        <p className="fw-regular text-center">
                          - Sábados de 8:00 a.m. a 1:00 p.m.
                        </p>
                      </div>
                    </div>
                    <div className="w-25 sede-div">
                      <div className="text-center mb-2">
                        <h4>
                          <i className="bi bi-geo-alt text-upch me-1" />
                        </h4>
                        <span className="fw-medium">Caja Sede Salaverry:</span>
                      </div>
                      <div className="text-center">
                        <p className="fw-regular text-center mb-0">
                          - Lunes a viernes de 8:00 a.m. a 8:00 p.m.{" "}
                        </p>
                        <p className="fw-regular text-center">
                          - Sábados de 8:00 a.m. a 4:45 p.m.
                        </p>
                      </div>
                    </div>
                    <div className="w-25 sede-div">
                      <div className="text-center mb-2">
                        <h4>
                          <i className="bi bi-geo-alt text-upch me-1" />
                        </h4>
                        <span className="fw-medium">Caja Sede Miraflores:</span>
                      </div>
                      <div className="text-center">
                        <p className="fw-regular text-center mb-0">
                          - Lunes a viernes de 10:00 a.m. a 7:00 p.m.
                        </p>
                        <p className="fw-regular text-center">
                          - Sábados de 9:00 a.m. a 3:00 p.m.
                        </p>
                      </div>
                    </div>
                    <div className="w-25 sede-div">
                      <div className="text-center mb-2">
                        <h4>
                          <i className="bi bi-geo-alt text-upch me-1" />
                        </h4>
                        <span className="fw-medium">Caja Sede La Molina:</span>
                      </div>
                      <div className="text-center">
                        <p className="fw-regular text-center mb-0">
                          - Lunes a viernes de 8:00 a.m. a 5:45 p.m.{" "}
                        </p>
                        <p className="fw-regular text-center">
                          - Sábados de 9:00 a.m. a 12:00 p.m.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div
                    className="alert alert-danger bg-white mt-2"
                    role="alert"
                  >
                    <span className="fw-medium">
                      <i className="bi bi-credit-card text-upch me-1" /> Puedes
                      pagar con tarjeta de crédito, débito o efectivo.
                    </span>{" "}
                    <br />
                  </div>
                  <p />
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer></Modal.Footer>
    </Modal>
  );
};
export default ModalPagoSeguro;